import { render, staticRenderFns } from "./AdminOrdersView.vue?vue&type=template&id=78c0cf02&scoped=true"
import script from "./AdminOrdersView.vue?vue&type=script&lang=js"
export * from "./AdminOrdersView.vue?vue&type=script&lang=js"
import style0 from "./AdminOrdersView.vue?vue&type=style&index=0&id=78c0cf02&prod&scoped=true&lang=scss"
import style1 from "./AdminOrdersView.vue?vue&type=style&index=1&id=78c0cf02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0cf02",
  null
  
)

export default component.exports